import React, {useCallback, useEffect, useMemo} from 'react';
import {NavLink, useLocation, useNavigate} from 'react-router-dom';
import {logout} from '@store/app.slice';
import {ReactComponent as TelegramIcon} from '@icons/Telegram.svg';
import {ReactComponent as AvitoIcon} from '@icons/Avito.svg';
import {ReactComponent as YandexMarketIcon} from '@icons/YandexMarket.svg';
import {ReactComponent as AutoRuIcon} from '@icons/AutoRu.svg';
import {ScreenshotRestsButton} from '@factories/SearchPageFactory/ScreenshotRestsButton';
import {TRACK_EVENTS, useTrack} from '@utils/track';
import {isSharedRestsPath} from '@utils/sharedRestsUrl';
import {useSharedRestsScreenshotTarget} from '../contexts/SharedRestsScreenshotContext';
import {Navigation, NavigationMobile} from '../components/Navigation';
import {ReactComponent as LogoFullIcon} from '../icons/LogoFull.svg';
import {ReactComponent as LogoForMobile} from '../icons/LogoForMobile.svg';
import {ReactComponent as LogoCompactIcon} from '../icons/LogoCompact.svg';
import {Avatar} from '../components/Avatar';
import {avatarSizes} from '../components/Avatar/types';
//import {CartSwitcher} from '../components/CartSwitcher';
import {useAppDispatch, useAppSelector, useResizeWindow} from '../hooks';
import {useGetUserProfileQuery} from '../pages/Profile/Profile.api';
import {HasAccess} from '../components/HasAccess';
import styles from './layouts.module.scss';

export const Header = () => {
    const width = useResizeWindow();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const screenshotTargetRef = useSharedRestsScreenshotTarget();
    const {token} = useAppSelector(state => state.app);
    const {data, isError} = useGetUserProfileQuery({token: token});
    const track = useTrack();

    const showScreenshotButton = isSharedRestsPath(location.pathname) && screenshotTargetRef;

    const handleSellOnClick = useCallback(() => {
        track({event: TRACK_EVENTS.robotyreClick});
    }, [track]);


    useEffect(() => {
        // todo разобраться почему не работает нормально
        // dispatch(logout({navigate}));
    }, [isError]);

    const renderAvatar = useMemo(() => <HasAccess><Avatar full_name={data?.full_name}
                                                          size={avatarSizes.m}/></HasAccess>, [data]);

    return (
        <div>
            <div className={styles.desktop}>
                <div className={styles.desktop__left}>
                    <NavLink to='/'>
                        {width < 1000 ? <LogoForMobile /> : <LogoFullIcon />}
                    </NavLink>
                </div>

                <div className={styles.desktop__center}>
                    <Navigation/>
                </div>

                <div className={styles.desktop__rightBox}>
                    {/*<NavLink to={'/profile'} className={styles.desktop__link}>*/}
                    {/*    <Plus width={12} height={12} color={colors.black}/>*/}
                    {/*    Добавить товары*/}
                    {/*</NavLink>*/}
                    {/*<CartSwitcher/>*/}
                    {showScreenshotButton && (
                        <ScreenshotRestsButton targetRef={screenshotTargetRef}/>
                    )}
                    <a
                        href="https://robotyre.ru/"
                        rel="noopener noreferrer"
                        target="_blank"
                        className={styles.sellOnButton}
                        onClick={handleSellOnClick}
                        aria-label="Продать на"
                    >
                        <span className={styles.sellOnButton__text}>Продать на</span>
                        <span className={styles.sellOnButton__icons}>
                            <AvitoIcon className={styles.sellOnButton__iconAvito} />
                            <YandexMarketIcon className={styles.sellOnButton__iconYm} />
                            <AutoRuIcon className={styles.sellOnButton__iconAutoRu} />
                        </span>
                    </a>
                    <a href="https://t.me/tyrebase" rel='noopener noreferrer' target='_blank' className={styles.desktop__link} aria-label="Наш TG">
                        <TelegramIcon className={styles.icon}/>
                        <span className={styles.desktop__linkText}>Наш TG</span>
                    </a>
                    {width > 998 ? renderAvatar : null}
                </div>
            </div>
            <NavigationMobile/>
        </div>
    );
};

